export function isTouchDevice(): boolean {
    return window.matchMedia('(hover: none) and (pointer: coarse)').matches;
}
